<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 class="text-uppercase mb-4" v-if="!question.subTitle">
        {{step + 1}} - {{ question.title }} {{ question.required === false ? '(Opcional)'  : '' }}
      </v-flex>
      <v-flex xs12 class="text-uppercase mb-4" v-else>
        <!-- {{ question.title }} -->
          <v-layout align-center>
            <v-flex shrink style="height:42px; flex-basis: 145px; min-width: 145px;max-width: 145px; padding:10px; background:red; webkit-print-color-adjust: exact;text-align: center; background: #d6a11f;color: white; text-transform: uppercase;">
              {{ question.title.split('.')[0] }}
            </v-flex>
            <v-flex style="color: #043a86;font-size: 20px;line-height: 22px;padding-left: 7px;">
              {{ question.title.replace('.', '|').split('|')[1] }}
            </v-flex>
          </v-layout>
      </v-flex>
      <v-flex xs12 v-if="question.subTitle" class="mb-4">
        {{step + 1}} - {{ question.subTitle }} {{ question.required === false ? '(Opcional)'  : '' }}
      </v-flex>
      <v-flex xs12 v-if="question.url" class="mb-4 grey--text">
        Avalie cada passo da concorrência segundo o guia 10 passos para uma concorrência legal da Abracom:
        <a :href="question.url" target="_blank">{{question.title.split('.')[0]}}</a>
      </v-flex>
      <v-flex xs12 v-if="question.type === 'options'">
        <v-radio-group v-model="value">
          <v-radio
            v-for="(label, index) in question.options"
            :key="index"
            :label="label"
            :value="index"
          ></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 v-else-if="question.type === 'checkbox' && question.options.length < 10">
        <v-checkbox
          v-for="(label, index) in question.options"
          :key="index"
          v-model="value"
          multiple
          :label="label"
          :value="index"
          hide-details
        ></v-checkbox>
      </v-flex>
      <v-flex xs12 v-else-if="question.type === 'checkbox' && question.options.length > 9">
        <v-layout>
          <v-flex xs12 md6>
            <v-checkbox
              v-for="(label, index) in [...question.options].splice(0, question.options.length % 2 === 0 ? question.options.length / 2 : question.options.length / 2 - 0.5)"
              :key="index"
              v-model="value"
              multiple
              :label="label"
              :value="index"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 md6>
            <v-checkbox
              v-for="(label, index) in  [...question.options].splice(question.options.length % 2 === 0 ? question.options.length / 2 : question.options.length / 2 - 0.5, question.options.length)"
              :key="index"
              v-model="value"
              multiple
              :label="label"
              :value="index + (question.options.length % 2 === 0 ? question.options.length / 2 : question.options.length / 2 - 0.5)"
              hide-details
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-else-if="question.type === 'text'">
        <v-text-field
          v-model="value"
          :label="question.label"
          @keypress.enter="$emit('next')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 v-else-if="question.type === 'textarea'">
        <v-textarea
          :label="question.label"
          v-model="value"
        ></v-textarea>
      </v-flex>
      <v-flex xs12 v-else-if="question.type === 'select'">
        <v-select
          :items="question.items"
          :label="question.label"
          v-model="value"
        ></v-select>
      </v-flex>
      <v-flex xs12 v-else-if="question.type === 'date'">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="value"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="value === '' ? '' : `${value.split('-')[1]}/${value.split('-')[0]}`"
              :label="question.label"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="value"
            type="month"
            no-title
            locale="pt-br"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
            <v-btn text color="primary" @click="$refs.menu.save(value)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  data () {
    return {
      menu: false
    }
  },
  methods: {
    ...mapMutations('form', ['setValue'])
  },
  computed: {
    ...mapGetters('form', ['question', 'step']),
    value: {
      get () {
        return this.question.value
      },
      set (value) {
        this.setValue(value)
      }
    }
  }
}
</script>

<style>

</style>
